import React from 'react';
import { StatutPaiement, TypeDocument } from '../../types';

interface StatusBadgeProps {
  statut: StatutPaiement;
}

const STATUS_STYLES: Record<StatutPaiement, string> = {
  [StatutPaiement.PAYEE]: 'bg-green-100 text-green-800 border-green-200',
  [StatutPaiement.PARTIELLEMENT_PAYEE]: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  [StatutPaiement.EN_RETARD]: 'bg-red-100 text-red-800 border-red-200',
  [StatutPaiement.NON_PAYEE]: 'bg-gray-100 text-gray-800 border-gray-200',
};

const STATUS_LABELS: Record<StatutPaiement, string> = {
  [StatutPaiement.PAYEE]: 'Payée',
  [StatutPaiement.PARTIELLEMENT_PAYEE]: 'Partiellement payée',
  [StatutPaiement.EN_RETARD]: 'En retard',
  [StatutPaiement.NON_PAYEE]: 'Non payée',
};

export function StatusBadge({ statut }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${STATUS_STYLES[statut]}`}
    >
      {STATUS_LABELS[statut]}
    </span>
  );
}

interface DocumentTypeBadgeProps {
  type: TypeDocument;
}

const TYPE_STYLES: Record<TypeDocument, string> = {
  [TypeDocument.FACTURE]: 'bg-blue-100 text-blue-800 border-blue-200',
  [TypeDocument.DEVIS]: 'bg-purple-100 text-purple-800 border-purple-200',
  [TypeDocument.AVOIR]: 'bg-orange-100 text-orange-800 border-orange-200',
  [TypeDocument.COMMANDE]: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  [TypeDocument.BON_LIVRAISON]: 'bg-teal-100 text-teal-800 border-teal-200',
  [TypeDocument.BON_COMMANDE]: 'bg-indigo-100 text-indigo-800 border-indigo-200',
};

const TYPE_LABELS: Record<TypeDocument, string> = {
  [TypeDocument.FACTURE]: 'Facture',
  [TypeDocument.DEVIS]: 'Devis',
  [TypeDocument.AVOIR]: 'Avoir',
  [TypeDocument.COMMANDE]: 'Commande',
  [TypeDocument.BON_LIVRAISON]: 'Bon de livraison',
  [TypeDocument.BON_COMMANDE]: 'Bon de commande',
};

export function DocumentTypeBadge({ type }: DocumentTypeBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${TYPE_STYLES[type]}`}
    >
      {TYPE_LABELS[type]}
    </span>
  );
}

export default StatusBadge;
